/******************************************************************************
 *
 * ExecutionHeader
 *
 * Displays selected Work Item information.
 *
 ******************************************************************************/

import React from "react";

export default function ExecutionHeader({

    work,

    workItem,

    maximized,

    onToggleMaximize,

    onClose

}) {

    return (

        <div
            className="text-white shadow-sm"
            style={{
                background:
                    "linear-gradient(135deg,#2563EB,#1E40AF)"
            }}
        >

            {/* ===================================================== */}
            {/* Top Header */}
            {/* ===================================================== */}

            <div className="d-flex justify-content-between align-items-center px-3 py-2">

                <div>

                    <div
                        className="fw-bold"
                        style={{
                            fontSize: "18px"
                        }}
                    >
                        Execute Work Item
                    </div>

                    <div
                        style={{
                            fontSize: "13px",
                            opacity: 0.9
                        }}
                    >
                        {workItem?.title || "-"}
                    </div>

                </div>

                <div className="d-flex align-items-center gap-2">

                    <button
                        type="button"
                        className="btn btn-sm btn-light"
                        title={
                            maximized
                                ? "Restore"
                                : "Maximize"
                        }
                        onClick={onToggleMaximize}
                    >
                        {maximized ? "🗗" : "🗖"}
                    </button>

                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        title="Close"
                        onClick={onClose}
                    >
                        ✕
                    </button>

                </div>

            </div>

            {/* ===================================================== */}
            {/* Work Details */}
            {/* ===================================================== */}

            <div
                className="px-3 py-2"
                style={{
                    background: "rgba(255,255,255,0.08)"
                }}
            >

                <div className="row g-2">

                    <div className="col-6">

                        <small
                            style={{
                                opacity: 0.8
                            }}
                        >
                            Work No
                        </small>

                        <div
                            className="fw-semibold"
                            style={{
                                fontSize: "14px"
                            }}
                        >
                            {work?.work_no || "-"}
                        </div>

                    </div>

                    <div className="col-6">

                        <small
                            style={{
                                opacity: 0.8
                            }}
                        >
                            Status
                        </small>

                        <div>

                            <span
                                className="badge"
                                style={{
                                    background:
                                        workItem?.status === "COMPLETED"
                                            ? "#16A34A"
                                            : workItem?.status === "IN_PROGRESS"
                                            ? "#F59E0B"
                                            : "#6B7280"
                                }}
                            >
                                {workItem?.status || "-"}
                            </span>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}